@if (tabItemsTemplateRef()) {
  <ng-container *ngTemplateOutlet="tabItemsTemplateRef()"></ng-container>
} @else if (tabItemsComponentRef()) {
  <ng-container *ngComponentOutlet="tabItemsComponentRef()"></ng-container>
} @else {
  <nav uipagentabheader [class]="headerCssClass()">
    @for (item of tabItems(); track item) {
      <a
        uipagetabitem
        *appHasRole="item.role"
        [routerLink]="item.routerLink"
        routerLinkActive="item.routerLinkActive"
      >
        @if (item.icon) {
          <icon
            uipagetabicon
            [iconDefinition]="item.icon.iconDefinition!"
            [iconSize]="item.icon.iconSize"
            [iconColor]="item.icon.iconColor"
          ></icon>
        }
        <span uipagetabitemtitle> {{ item.title }} </span>
      </a>
    }
  </nav>
}
<div uipagetabcontent [class]="contentCssClass()">
  <router-outlet></router-outlet>
</div>
